import {
  Heading as ChakraHeading,
  HeadingProps as ChakraHeadingProps,
  Text as ChakraText,
  TextProps as ChakraTextProps,
  useStyleConfig,
} from '@chakra-ui/react';
import React from 'react';

type ExposedHeadingProps = Omit<ChakraHeadingProps, 'as' | 'size'>;

const H1: React.FC<ExposedHeadingProps> = ({ children, ...props }) => (
  <ChakraHeading as="h1" size="2xl" {...props}>
    {children}
  </ChakraHeading>
);

const H2: React.FC<ExposedHeadingProps> = ({ children, ...props }) => (
  <ChakraHeading as="h2" size="xl" {...props}>
    {children}
  </ChakraHeading>
);

const H3: React.FC<ExposedHeadingProps> = ({ children, ...props }) => (
  <ChakraHeading as="h3" size="lg" {...props}>
    {children}
  </ChakraHeading>
);

const H4: React.FC<ExposedHeadingProps> = ({ children, ...props }) => (
  <ChakraHeading as="h4" size="md" {...props}>
    {children}
  </ChakraHeading>
);

const H5: React.FC<ExposedHeadingProps> = ({ children, ...props }) => (
  <ChakraHeading as="h5" size="sm" {...props}>
    {children}
  </ChakraHeading>
);

const H6: React.FC<ExposedHeadingProps> = ({ children, ...props }) => (
  <ChakraHeading as="h6" size="xs" {...props}>
    {children}
  </ChakraHeading>
);

const Blockquote: React.FC<ChakraTextProps> = ({ children, ...props }) => {
  const style = useStyleConfig('Blockquote');
  return (
    <ChakraText sx={style} {...props} as="blockquote">
      {children}
    </ChakraText>
  );
};

const Text: React.FC<ChakraTextProps> = ({ children, as, ...props }) => {
  if (as === 'blockquote') {
    return <Blockquote {...props}>{children}</Blockquote>;
  }
  return (
    <ChakraText as={as} {...props}>
      {children}
    </ChakraText>
  );
};

const ImageCaption: React.FC<ChakraTextProps> = ({ children, ...props }) => {
  return (
    <ChakraText color="gray.600" fontSize="xs" fontStyle="italic" {...props}>
      {children}
    </ChakraText>
  );
};

export { H1, H2, H3, H4, H5, H6, ImageCaption, Text };
